<template>
  <team
    :items="items"
    :loading="loading"
    :search="search"
    :is-integrated="isIntegrated"
    :page-size="pageSize"
    @get-profiles-data="getProfilesData"
    @click="onClick"
    @on-search="onSearch"
  />
</template>
<script>
import Listable from '@/components/mixins/listable';
import { FETCHING } from '@/_store/profile.module';
import _ from 'lodash';
import integrable from '@/components/mixins/integrable';
import Team from './Team';

export default {
  name: 'TeamContainer',
  components: {
    Team,
  },
  mixins: [Listable, integrable],
  props: {
    source: {
      type: String,
      default: 'profiles',
    },
  },
  data() {
    return {
      queryParams: {
        profile_sorting: true,
      },
      page: 1,
      pageSize: 10,
    };
  },
  computed: {
    items() {
      if (!this.$store.state.profiles.items) {
        return [];
      }
      return this.$store.state.profiles.items;
    },
    loading() {
      return this.$store.state.profiles.status === FETCHING;
    },
  },
  mounted() {
    this.getProfilesData();
  },
  methods: {
    onClick(itemIndex) {
      this.$router.push(`/admin/user/${this.items[itemIndex].pk}`);
    },
    // eslint-disable-next-line
    onSearch: _.debounce(function (evt) {
      this.search = evt;
    }, 200),
    getProfilesData(profileParams = { page: this.page, page_size: this.pageSize }) {
      const kwargs = {
        ...profileParams,
        search: this.search,
        profile_sorting: true,
      };
      this.$store.dispatch('profiles/fetchAll', kwargs);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
